require('../styles.css');
"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/icons/monochrome/IconFire.tsx
var IconFire_exports = {};
__export(IconFire_exports, {
  default: () => IconFire_default
});
module.exports = __toCommonJS(IconFire_exports);

// src/assets/monochrome/fire.svg
var import_jsx_runtime = require("react/jsx-runtime");
var SvgFire = (props) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.64325 3.27305C7.76658 2.58416 7.81294 1.83442 7.75 1C8.47785 1.45049 9.06228 2.07852 9.52449 2.80423C9.60544 2.93132 9.68263 3.06141 9.75619 3.19406C10.0561 3.73494 10.2956 4.3185 10.4824 4.91567C10.898 6.24426 11.0527 7.64022 11.0313 8.78344C11.4694 8.44531 11.9144 7.75325 12.124 6.87371C12.2956 6.15355 12.3093 5.30769 12.032 4.42748C12.1114 4.48325 12.1897 4.54006 12.2669 4.59789C12.9426 5.10444 13.5303 5.68869 14.0268 6.33265C15.3244 8.01528 16 10.1056 16 12.2829C16 15.6894 13.954 19.0239 10 18.9999C6.046 18.9759 4 16.2226 4 12.9969C4 10.7708 4.91332 9.18038 5.84185 7.56344C6.58763 6.26474 7.34321 4.94896 7.64325 3.27305ZM8.82491 5.65424C8.46157 6.57986 8.01363 7.3909 7.5908 8.13173C7.5447 8.2125 7.49916 8.29211 7.45423 8.37067C6.48771 10.0604 5.8 11.2628 5.8 12.9969C5.8 14.2374 6.19153 15.2725 6.84266 15.9811C7.47257 16.6666 8.4756 17.1906 10.0109 17.1999C11.4204 17.2085 12.4049 16.6432 13.0775 15.803C13.7859 14.918 14.2 13.6496 14.2 12.2829C14.2 10.9925 13.9154 9.75672 13.3703 8.66189C13.0532 9.27846 12.6324 9.8214 12.1313 10.2083L9.16171 12.5007L9.23165 8.74989C9.2488 7.83007 9.13001 6.71409 8.82491 5.65424Z", fill: "#676F7E" }) });
var fire_default = SvgFire;

// src/Wrappers/helpers.ts
var getIconBaseCssVariables = ({
  size,
  rotate,
  transitionDuration
}) => {
  return {
    "--icon-size": size ? `${size}px` : "100%",
    "--icon-rotate": rotate ? `${rotate}deg` : "0deg",
    // Browser cannot handle multiple transitions on the same property if another variable (e.g. --transition-duration)
    // is defined on another element.
    "--icon-transition-fill": transitionDuration ? `fill ${transitionDuration} ease` : "none",
    "--icon-transition-transform": transitionDuration ? `transform ${transitionDuration} ease` : "none"
  };
};
var getIconColoringCssVariables = ({
  state,
  color,
  activeColor
}) => {
  return {
    "--icon-color": state === "active" ? activeColor : color,
    "--icon-active-color": state === "disabled" || !activeColor ? color : activeColor
  };
};

// src/Wrappers/IconWrapper.tsx
var import_jsx_runtime2 = require("react/jsx-runtime");
var getWrapperStyles = (props) => ({
  ...getIconBaseCssVariables(props),
  ...getIconColoringCssVariables(props)
});
var IconWrapper = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(
    "div",
    {
      className: "ui-icon-size-wrapper ui-icon-coloring-wrapper",
      style: getWrapperStyles(props),
      children: props.children
    }
  );
};

// src/icons/monochrome/IconFire.tsx
var import_jsx_runtime3 = require("react/jsx-runtime");
var IconFire = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(IconWrapper, { ...props, children: /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(fire_default, {}) });
};
IconFire.displayName = "IconFire";
var IconFire_default = IconFire;
